module.exports = __webpack_public_path__ + "static/media/ic-key.7ab9b561.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-key.svg
// module id = 633
// module chunks = 14